export enum Role {
  PROGRAM_MANAGER = 'PROGRAM_MANAGER',
  GUARD = 'GUARD',
  OPERATOR = 'OPERATOR',
  READ_ONLY_USER = 'READ_ONLY_USER',
  IMPLEMENTER = 'IMPLEMENTER',
  UNKNOWN = 'UNKNOWN',
}
